import React from 'react'

import { GridPinnedColumns } from '@mui/x-data-grid-pro'
import { GridColDef } from '@mui/x-data-grid-pro'
import styled from 'particles/themes/styled'
import { TableViewType } from 'components/Shared/MuiTable'
import styles from 'components/Team/Member/MemberTable/styles'
import { useWindowHeight } from 'hooks'
import PartiTable from 'components/Shared/MuiTable/PartiTable'

interface MemberTableProps {
    className?: string
    isLoading: boolean
    rows: any[]
    columns: GridColDef[]
    pinnedColumns?: GridPinnedColumns
    hasCreateButton: boolean
}

const MemberTable: React.FC<MemberTableProps> = ({
    className,
    isLoading,
    columns,
    rows,
    pinnedColumns,
    hasCreateButton,
}) => {
    const windowHeight = useWindowHeight()
    return (
        <div className={className}>
            <PartiTable
                rowHeight={80}
                columns={columns}
                rows={rows}
                hideToolbar={true}
                enableExport={false}
                showFilter={false}
                showSearchBar={false}
                viewType={TableViewType.TEAM_MEMBER_LIST}
                disableColumnMenu={true}
                hideFooterRowCount={true}
                displayPagination={false}
                isLoading={isLoading}
                hideTableBorder
                noPadding
                tableHeight={windowHeight && windowHeight < 760 ? '66vh' : hasCreateButton ? '78vh' : '83vh'}
                pinnedColumns={pinnedColumns}
                hideFooter={true}
            />
        </div>
    )
}

export default styled(MemberTable)`
    ${styles}
`
